import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';

class SubjectSelector extends Component<any, any> {
  constructor(props: any){
    super(props);
  }

  componentDidMount() {
  }

  render() {
    return (
      <div className="container frontend">
      </div>
    );
  }
}

export default observer(SubjectSelector);
